import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Observable'
import { HttpClient } from '@angular/common/http'
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router'
import { BankModel } from '../../models/bank.model'
import { BehaviorSubject } from 'rxjs'
import { environment } from '../../../../environments/environment'

@Injectable()
export class BankService implements Resolve<Observable<BankModel[]>> {
  private readonly URL = environment.base_url + '/v2/banks'
  onBanksChanged: BehaviorSubject<BankModel[]> = new BehaviorSubject<BankModel[]>(undefined)

  constructor(protected httpClient: HttpClient) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<BankModel[]> {
    return this.browse()
  }

  /**
   *
   */
  public browse(): Observable<BankModel[]> {
    return this.httpClient.get<BankModel[]>(`${this.URL}`).map((response: BankModel[]) => {
      const banks = []
      for (const bank of response) {
        banks.push(new BankModel(bank))
      }
      this.onBanksChanged.next(banks)
      return banks
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/main/services/bank/bank.service.ts